@if (isScrolled) {
  <dds-button size="lg"
              theme="blue"
              kind="primary"
              icon="dds-icon_arrow_up__s__stroke"
              class="scroll-top"
              [isInverse]="true"
              (clicked)="scrollToTop()"></dds-button>
}
